import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import CustomAlert from '../../components/CustomAlert';
import CustomLoading from '../../components/CustomLoading';
import { paths } from '../../config/router.config';
import wsclients from '../../services/wsclients';
import t from '../../utils/translateUtil';
import { readMWCode } from '../../utils/util';
import PublicPage from '../PublicPage'
import ResetPasswordView from './ResetPasswordView';

export default function ForgotPasswordController(props) {
    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState({});
    const { t } = useTranslation();
    const history = useHistory();

    const onShowMessage = (message) => {
        onShowLoading(false)
        setMessage(message)
    }

    const onReset = async (values) => {
        onShowLoading(true);
        console.log('onForgotPassword values===', values)
        if (values && values.email)
            try {
                var result = await wsclients.contacts.forgotPassword(values.email);
                console.log("onForgotPassword result:",result);
                if (result.code == 'OK') {
                    onShowMessage({ show: true, content: t('FORGOT_PASSWORD_SUCCESS') });
                } else if (result.code == 'FORGOT_EMAIL_NOT_FOUND_EXCEPTION') {
                    onShowMessage({ show: true, content: t('FORGOT_EMAIL_NOT_FOUND_EXCEPTION') });
                } else if (result.code == 'TOO_MANY_REQUESTS') {
                    onShowMessage({ show: true, title: t('ERROR'), content: t('TOO_MANY_REQUESTS') });
                } else if (result.code == 'TOO_MANY_RECIPIENTS_EXCEPTION') {
                    onShowMessage({ show: true, title: t('ERROR'), content: t('TOO_MANY_RECIPIENTS_EXCEPTION') });
                } else {
                    onShowMessage(true, t('FORGOT_PASSWORD_FAIL'));
                }
            } catch (error) {
                console.log("on forgot password exception:", error);
                onShowMessage({ show: true, content: t('EXCEPTION_PROCESS') });
            }
        onShowLoading(false);
    }

    const onCancel = () => {
        history.push(paths.login);
    }

    return (
        <>
            <PublicPage
                rightComponent={
                    <ResetPasswordView
                        onReset={onReset}
                        onCancel={onCancel}
                    />
                }
            />
            {message.show && <CustomAlert
                open={message.show}
                message={message.content}
                showButtonClose={true}
                onClose={() => onShowMessage({})}
            />}
            {showLoading && <CustomLoading open={showLoading} />}
        </>
    );
}